import type { Permission } from '@squadcore/api/shared/permissions'
import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'
import { sessionQuery } from '~/lib/session'

/** Loaders prefetch only what the member may read, so a missing right never fires a 403. */
export async function mayAny(queryClient: QueryClient, permissions: Permission[]) {
  const session = await queryClient.ensureQueryData(sessionQuery)
  return permissions.some((p) => session.active?.permissions.includes(p))
}

export const mayRead = (queryClient: QueryClient, permission: Permission) => mayAny(queryClient, [permission])

/**
 * beforeLoad guard for admin pages: without the right a deep link, bookmark or notification lands on
 * the start page instead of a 403 from the loader (frontend-ux §7.8).
 */
export async function requirePagePermission(queryClient: QueryClient, permission: Permission) {
  if (!(await mayRead(queryClient, permission))) throw redirect({ to: '/' })
}
